import { HttpService } from './HttpService';

export class LayoutImageResponse {
    public id: number = 0;
    public restaurant_id: number = 0;
    public width: number = 0;
    public height: number = 0;
    public url: string = "";
}

export class LayoutService extends HttpService {

    constructor(url: string) {
        super(url);
    }

    public async getLayoutImage(): Promise<LayoutImageResponse> {
        const result = new LayoutImageResponse();

        try {
            const response = (await this.get("/tables/layout")).data;

            result.id = response.id;
            result.restaurant_id = response.restaurant_id;
            result.width = response.width;
            result.height = response.height;
            result.url = response.url;

        } catch (e) { console.error("Failed to get layout image", e) }

        return result;
    }
}
